import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { DomainHeader } from '../../components/ui/DomainHeader';
import { Tabs } from '../../components/ui/Tabs';
import { EventsBoard } from '../../components/community/EventsBoard';
import { PeopleDirectory } from '../../components/community/PeopleDirectory';
import { GroupsPanel } from '../../components/community/GroupsPanel';
import { Messages } from '../../components/community/Messages';
import { conversations } from '../../data/community';
import { account } from '../../data/account';
import { useDataMode } from '../../contexts/DataModeContext';
import { FirstRun } from '../../components/platform/FirstRun';
const TABS = ['Events', 'People', 'Groups', 'Messages'] as const;
export function Community() {
  const [tab, setTab] = useState<(typeof TABS)[number]>('Events');
  const unread = conversations.reduce((total, conversation) => total + conversation.unread, 0);
  const {
    isNew
  } = useDataMode();
  if (isNew) {
    return <FirstRun surface="Community" what="The people, groups and conversations behind everything else you do here." why="Course groups answer the questions a handbook does not, event listings tell you what is actually on this week, and every conversation you hold — with a housemate, a tutor, a provider or a property manager — arrives in one place with the record it belongs to attached." note="Nobody can see your notes, results, wellbeing activity or balances through your profile, whatever you make visible. Following someone is not the same as connecting with them, and neither grants access to anything you have not published." steps={[{
      label: 'Join a course or department group',
      detail: 'Some groups need your programme or level verified. Where you do not qualify, the requirement is stated rather than the group being hidden.'
    }, {
      label: 'Find people you already know',
      detail: 'Search by @handle or name. You choose who may message you before anyone does.'
    }, {
      label: 'Decide what your profile shows',
      detail: 'Set it before you are discoverable, not after.',
      to: '/settings'
    }]} data-id="element-10138" data-mp="1sejxm2wkoffa" />;
  }
  return <div className="space-y-6" data-id="element-10139" data-mp="2748kphuf854h">
      <DomainHeader domain="social" eyebrow="Campus community" title="Your people, groups and what is happening" description="Events, student organizations, friends and following, and every conversation you hold on Campuzon — all addressed by your handle." actions={<div className="flex flex-wrap items-center gap-2" data-id="element-10141" data-mp="2lxv3fu9g0smj">
            <Badge tone="brand" data-id="element-10142" data-mp="3sfrw5kykxtfz">@{account.username}</Badge>
            {unread > 0 && <Badge tone="warn" data-id="element-10143" data-mp="1977g7vzyxm4">{unread} unread</Badge>}
            <Link to="/money" data-id="element-10144" data-mp="1btiwim0dx9m">
              <Button size="sm" variant="secondary" data-id="element-10145" data-mp="1lsj3mai2jk86">
                Shared expenses
              </Button>
            </Link>
          </div>} data-id="element-10140" data-mp="2751hbpzo1e8w" />

      <Tabs tabs={TABS} value={tab} onChange={setTab} label="Community sections" data-id="element-10146" data-mp="1gv14fbtusjdd" />

      {tab === 'Events' && <EventsBoard data-id="element-10147" data-mp="1bzv9jnih3ud5" />}
      {tab === 'People' && <PeopleDirectory data-id="element-10148" data-mp="173wp2b09mwi0" />}
      {tab === 'Groups' && <GroupsPanel data-id="element-10149" data-mp="1710tuufsylx9" />}
      {tab === 'Messages' && <Messages data-id="element-10150" data-mp="124jvl7ew2r6g" />}
    </div>;
}